<script>
import RatingNote from "@/components/reviews/RatingNote.vue";
import RatingGlobalPlan from "@/components/reviews/RatingGlobalPlan.vue";
import ReviewItem from "@/components/reviews/product/ReviewItem.vue";
import ModalReview from "@/components/reviews/product/ModalReview.vue";
import {useAuthStore} from "@/stores/auth";

export default {
  name: 'ProductReview',
  methods: {useAuthStore},
  components: {ModalReview, ReviewItem, RatingGlobalPlan, RatingNote},
  props: {
    product: {
      type: Object,
      required: true
    },
    reviews: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewModal: false
    }
  },
  computed: {
    numberOfReviews () {
      return this.reviews ? this.reviews.length : 0
    },
    getNote () {
      let note = 0
      Object.values(this.reviews).map(review => {
        note += review.note
      })
      if (note > 0) {
        return (note / this.reviews.length).toFixed(1)
      }
      return 0
    }
  }
}
</script>

<template>
  <section id="avis" class="bg-white py-8 antialiased dark:bg-gray-900 md:py-16">
    <div class="mx-auto max-w-screen-xl px-4 2xl:px-0">
      <div class="flex items-center gap-2">
        <h2 class="text-2xl font-semibold text-gray-900 dark:text-white">
          Avis clients
        </h2>
        <div class="mt-2 flex items-center gap-2 sm:mt-0">
          <rating-note :number-reviews="numberOfReviews" :note="getNote" />
        </div>
      </div>

      <div class="my-6 gap-8 sm:flex sm:items-start md:my-8">
        <div class="shrink-0 space-y-4">
          <p class="text-2xl font-semibold leading-none text-gray-900 dark:text-white">
            {{ getNote }}/5
          </p>
          <button v-if="useAuthStore().isConnected" @click="viewModal = true" class="mb-2 me-2 rounded-lg bg-primary-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-primary-800 focus:outline-none">
            Ecrire un avis
          </button>
        </div>
        <rating-global-plan :reviews="reviews" />
      </div>
      <div v-if="reviews.length > 0" class="mt-20 divide-y divide-gray-200">
        <review-item v-for="(review, index) in reviews" :key="index" :review="review" />
      </div>
      <div v-else class="text-center text-lg">
        Aucun avis
      </div>
    </div>
    <modal-review v-if="viewModal" :product="product" @close-modal="viewModal = false" />
  </section>
</template>
